module.exports = __webpack_public_path__ + "static/media/quality-slide2.9fa2d4da.jpg";